import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { Auth } from 'aws-amplify';
import { JobService } from '../../../services/job.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  jobDetailsData;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    // { title: 'Profile' },
    { title: 'Support / Feedback' },
    { title: 'Log out' },
  ];

  routeContainsJob: boolean = false;

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private breakpointService: NbMediaBreakpointsService,
    public authenticator: AuthenticatorService,
    private jobService: JobService,
    private router: Router
  ) {
    this.menuService.onItemClick().subscribe(event => {
      this.onContecxtItemSelection(event.item.title);
    });
    this.jobService.toolbarValues$.subscribe(res => this.jobDetailsData = res);
  }

  ngOnInit() {
    this.currentTheme = this.currentTheme;
    this.changeTheme(this.currentTheme);
    Auth.currentAuthenticatedUser().then(user => {
      this.user = {
        name: user?.attributes?.email,
        userPictureOnly: false,
      };
    });

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  onContecxtItemSelection(title: string) {
    if (title === 'Log out') {
      this.authenticator.signOut();
    } else if (title === 'Support / Feedback') {
      window.open('https://auxilis-au.atlassian.net/servicedesk/customer/portal/15', '_blank');
    }
  }


  headerToggle(e) {
    this.jobService.headerToggle(e);
  }

  async changePage(res) {
    this.jobService.changePage(res);
  }

  onPopverAddCommentClick () {
    this.jobService.onPopverAddCommentClick();
  }

  onReprocessClick () {
    this.jobService.onReprocessClick ();
  }

  jobVerifiedStatus(e) {
    return this.jobService.jobVerifiedStatus(e);
  }

  export(e) {
    this.jobService.export(e);
  }

  async proceedToNextJob (res) {
    this.jobService.proceedToNextJob(res);
  }

  horizontalButton () {
    this.jobService.horizontalButton();
  }

  verticalButton () {
    this.jobService.verticalButton();
  }

  undoButton () {
    this.jobService.undoButton();
  }

  proceedButton () {
    this.jobService.proceedButton();
  }

  async undoTableChanges () {
    this.jobService.undoTableChanges();
  }

  layerButton () {
    this.jobService.layerButton();
  }

  infoClick () {
    this.jobService.infoClick();
  }

  navigateToJobsRoute(projectName) {
    this.router.navigate([`/pages/jobs/${projectName}`]);
  }

  async deskew (res) {
    this.jobService.deskew(res);
  }

}
